import { useState } from 'react'
import Categories from './Categories';
import items from './data';
import Carta from './Carta';
import { motion } from 'framer-motion';

const Menu = () => {
  const [menuItems, setMenuItems] = useState(items);
  const [categories, setCategories] = useState([]);


  const filterItems = (category) => {
    if (category === 'all') {
      setMenuItems(items);
      return
    }

    const newItems = items.filter((item) => item.category === category)
    setMenuItems(newItems)
  }

  return (
    <motion.div 
    initial={{opacity: 0}}
    whileInView={{opacity: 1}}
    viewport={{once: true}} >
    <main>
      <section className="menu-section">
        <div className="title">
        <h2>Our Menu</h2>
        <div className="underline"></div>
        </div>
      <Categories filterItems = {filterItems}/>
      <Carta items= {menuItems} />
      </section>
    </main>  
    </motion.div> 
  )
}

export default Menu